import * as React from 'react';

import type {EmailAutomation as EmailAutomationFragment} from 'nutshell-graphql-types';

import {NUTSHELL_EMAIL_MARKETING} from '../../constants';
import type {EmailType} from '../../types';

import {SalesAutomationCardEmail} from '../cards/sales-automation-card-email';
import {SalesAutomationCardEmailWrapper} from '../cards/sales-automation-card-email-wrapper';

import {CardsContainer} from './cards-container';

type Props = {
    parentId: string;
    isLoading: boolean;
    hideCards: boolean;
    // @ts-expect-error
    errorMessage: string | React.ReactElement<React.ComponentProps<string>> | null | undefined;
    emailAutomations: EmailAutomationFragment[] | [];
    type: EmailType;
};

export class StageCardsEmailsContainer extends React.PureComponent<Props> {
    render() {
        const cards = this.props.emailAutomations.map((email, index) => {
            if (!email) {
                return (
                    <SalesAutomationCardEmailWrapper
                        key={`${index}-${this.props.parentId}`}
                        isHidden={this.props.hideCards}
                        size={this.props.type === NUTSHELL_EMAIL_MARKETING ? 'large' : 'small'}
                    />
                );
            }

            return (
                <SalesAutomationCardEmail
                    key={email.id}
                    type={this.props.type}
                    isHidden={this.props.hideCards}
                    emailAutomation={email}
                />
            );
        });

        return (
            <CardsContainer
                type={this.props.type}
                isLoading={this.props.isLoading}
                hideAddCard={this.props.hideCards}
                errorMessage={this.props.errorMessage}
                isCardBeingDragged={false}
                parentId={this.props.parentId}
            >
                {cards}
            </CardsContainer>
        );
    }
}
